import React from 'react';
import { CustomRoute } from 'util/hook/useRouter';

import { getEyeCheckImageListReportList } from 'models/eyeCheckImageReport';
import { ROUTE_PATHS } from 'models/sideMenu';
import { checkAuthGuard } from 'models/auth';

// import InpatientListInner from './Inner';

const routes: CustomRoute = {
	path: '/eye-check-image',
	components: () => [],
	render: (_, children) => children,
	onEnter: async ({ next }) => {
		const children = await next();
		return children;
	},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'inpatientList' */ './component')],
			render: ([EyeCheckImage]) => <EyeCheckImage />,
			onEnter: async ({ store, next }) => {
				console.log('on Enter Eye Check Image');
				const allowEnter = checkAuthGuard(store, `/${ROUTE_PATHS.EYE_CHECK_IMAGE}`);
				if (allowEnter) {
					await store.dispatch(getEyeCheckImageListReportList('OBSGYN/PED', 'Ultrasound', ''));
				}
				const children = await next();
				return children;
			},
		},
		// InpatientListInner,
	],
};
export default routes;
